module.exports = __webpack_public_path__ + "img/zhifubao.e9fe2194.png";